<template>
  <div class="">
    <div class="index_oo">
      <div class="index1_until cpoint">
        <div class="index1_until_shu"></div>
        <div class="index1_until_text">企业列表</div>
      </div>
      <div class="box3 cpoint">
        <div class="box3_right" style="width: 100%">
          <div class="box3_center" style="width: 100%">
            <input @keyup.enter.prevent="searchEnterFun($event)" v-model="keyword" placeholder="请输入您要搜索的关键词" />
            <div @click="tosearch" class="box3_sou">
              <div class="box3_tu">
                <img style="width: 25px;height: 25px;" src="/static/assets/images/sou.png" />
              </div>
              <div>搜索</div>
            </div>
          </div>
          <!-- <div class="box3_lie">导出列表</div> -->
        </div>
      </div>
      <div class="box55 cpoint">
        <div class="box2">
          <div class="box2_center" style="min-height: 545px;">
            <table
              class="bo"
              cellpadding="0"
              cellspacing="0"
              style="font-size: 15px"
            >
              <tr class="bo_cc" style="font-size: 18px">
                <td>企业名称</td>
                <td style="width: 260px;">企业联系人</td>
                <td style="width: 260px;">联系人电话</td>
                <td>租赁房间号</td>
                <td>租赁时长</td>
                <td>入驻时间</td>
                <td>操作</td>
              </tr>
              <tr v-for="(item,index) in list" :key="index" class="trcla">
                <td>{{item.shop.shop_name ? item.shop.shop_name : '--'}}</td>
                <td style="width: 260px;">{{item.shop.people_name ? item.shop.people_name : '--'}}</td>
                <td style="width: 260px;">{{item.shop.mobile ? item.shop.mobile : '--'}}</td>
                <td>{{item.room_number ? item.room_number : '--'}}</td>
                <td>{{item.lease_time ? item.lease_time : '--'}}</td>
                <td>{{item.shop.createtime ? item.shop.createtime : '--'}}</td>
                <td @click="showdetail(item)" class="box2_tt flex justify-around align-center pointer" style="color: #6491ff;">
                  详情
                </td>
              </tr>
            </table>
            <div @click="emptyedit">
                <nomore v-if="!list.length" ></nomore>
            </div>
          </div>
          <div class="response text-center padding-tb">
            <el-pagination
              background
              :page-size="pagesize"
              :hide-on-single-page="true"
              layout="prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :total="totalnum">
              </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="企业详情" :visible.sync="addcompany">
      <div class="" v-if="cominfo" style="text-align: center;width: 60%;margin: 0 auto;">
        <el-form :model="cominfo" style="text-align:center;">
          <el-form-item label="企业名称" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.shop_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="企业联系人" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.people_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.mobile" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.add_detail" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="所属分类" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.cat_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="入驻时间" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.createtime" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="租赁房间号" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.room_number" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="租赁时长" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.lease_time" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="支付方式" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.pay_way" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="房租价格" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.price" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="费用到期时间" :label-width="formLabelWidth">
            <!-- <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.expire_time" autocomplete="off"></el-input> -->
            <el-date-picker
                  v-model="cominfo.expire_time"
                  type="date"
                  disabled
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  style="width: 420px;"
            >
                </el-date-picker>
          </el-form-item>
          <el-form-item label="到期应收" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.real_money" autocomplete="off"></el-input>
          </el-form-item>

        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return{
      list: [],
      keyword: '',
      pagesize: 8,
      currentPage: 1,
      totalnum: null,
      systeminfo: '',
      addcompany: false,
      formLabelWidth: '120px',
      cominfo: '',
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  methods:{
    showdetail(item){
      this.cominfo = item;
      this.addcompany = true;
    },
      emptyedit(){
      this.addcompany = true;
    },
    handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        // console.log(this.currentPage)  //点击第几页
        // this.rightlist = [];
        this.getlist();
    },
    handleSizeChange(size){
        // this.pagesize = size;
        console.log(size)  //每页下拉显示数据
    },
    // policy_matching_list
    outweb(link){
      window.open(link,'_target')
    },
    getlist(){
      var data ={
        keyword: this.keyword,
        start: this.currentPage,
        page_size: this.pagesize,
        admin_id: this.token
      }
      this.$api.system.system_shop_list(data).then(res=>{
        this.list = res.data;
        this.totalnum = res.count;
        console.log(res)
      })
    },
    searchEnterFun(e){
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
          this.tosearch();
      }
		},
    tosearch(){
      this.list = [];
      this.currentPage = 1;
      this.totalnum = 0;
      this.getlist();
    },
    todetail(id){
      this.$router.push({name: 'zcpolicydetail',query:{type: this.type,id: id}})
    },
    tocom(id){
      // companydetail
       this.$router.push({name: 'companydetail',query:{path: 'zcpolicy',id: id}})
    },
    tofollow(id,company_id){
      var api = this.$api.api.vector.follow_up;
      this.$https.post({
        type: 'formData',
        api: api
      },{
        company_id: company_id,
        policy_id: id,
        user_id: this.userid,
        super_id: this.systeminfo.super_id
      },
      response=>{
        this.$message({
          message: response.msg,
          type: "success",
        });
        this.getlist();
      },
      error=>{
        this.$message({
          message: error.msg,
          type: "warning",
        });
      })
    },
  },
  created(){
    this.getlist();
  }
}
</script>
<style scoped>
.index_oo {
  min-height: 666px;
  justify-content: flex-start !important;
}
.box55{
    width: 100%;
}
.bo {
  margin-top: 24px;
  /* margin-bottom: 70px; */
  border-bottom: 1px solid #efefef;
  width: 100%;
}
.bo_cc {
  background-color: #6491ff;
  font-size: 18px;
  color: #ffffff;
}
.bo_cc td {
  height: 56px;
  line-height: 56px;
  text-align: center;
  padding: 0 9px;
  border-top: 1px solid #efefef;
  border-left: 1px solid #efefef;
}
.trcla td {
  /* line-height: 85px; */
  text-align: center;
  padding: 0 9px;
  height: 60px;
  border-top: 1px solid #efefef;
  border-left: 1px solid #efefef;
}
.box2_text {
  height: 30px;
  background-color: #ffffff;
  border-radius: 15px;
  border: solid 1px #6491ff;
  font-size: 14px;
  color: #6491ff;
  margin-left: 13px;
  padding: 0 20px;
  line-height: 30px;
  text-align: center;
}

.box2_text1 {
  width: 91px;
  height: 30px;
  background-color: #6491ff;
  border-radius: 15px;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box2 {
  width: 95%;
  margin: 0 auto;
}
.box3 {
  display: flex;
  width: 95%;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}
.box3_center {
  width: 83%;
  height: 48px;
  background-color: #ffffff;
  box-shadow: 0px 2px 18px 0px rgba(141, 142, 144, 0.24);
  border-radius: 8px;
  border: solid 1px #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box3_lie {
  width: 123px;
  height: 42px;
  background-color: #ffffff;
  border-radius: 21px;
  border: solid 1px #6491ff;
  font-size: 18px;
  color: #6491ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
}
.box3_lie1 {
  width: 123px;
  height: 42px;
  background-color: #6491ff;
  border-radius: 21px;
  border: solid 1px #6491ff;
  font-size: 18px;
  color: #ffffff;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 70px;
}
.box3_right {
  width: 64%;
  display: flex;
  align-items: center;
  position: relative;
}
input {
  width: 90%;
  background: none;
  outline: none;
  border: none;
  margin-left: 20px;
}
.box3_tu {
  width: 25px;
  height: 25px;
  margin-right: 8px;
}
.box3_sou {
  display: flex;
  width: 90px;
  align-items: center;
  height: 100%;
  font-size: 18px;
  color: #6491ff;
}
.box3_text {
  font-size: 18px;
  color: #a3a3a3;
  height: 35px;
  display: flex;
  padding: 0 7px;
  align-items: center;
  border-bottom: 4px solid #ffffff;
}
td:last-child {
  border-right: 1px solid #efefef;
}
</style>



// WEBPACK FOOTER //
// companylist.vue?22e7e5b0